<div *ngIf="!fecharAddCategoria">
  <div class="flex items-center justify-center">
    <button
      (click)="hideModal()"
      type="button"
      class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto right-0"
    >
      X
    </button>
  </div>
  <ng-container>
    <h1 class="text-lg font-bold leading-3">CRIAR CATEGORIA</h1>
    <small class="text-xs text-chathams-blue"
      >Crie aqui uma catogoria para que ela seja pai de algum questionário</small
    >

    <form class="grid grid-cols-3 gap-5" [formGroup]="formCategoria" (ngSubmit)="salvarCategoria()">
      <input type="text" class="form-input" placeholder="*Nome" formControlName="name" />
      <input type="text" class="form-input" placeholder="*Descrição" formControlName="description" />

      <button type="submit" class="h-9 btn btn--secondary">Adicionar Categoria</button>
    </form>
  </ng-container>
</div>
